<div *ngIf="success" class="alert alert-success alert-dismissible fade show">
  {{ successMessage }}
  <button (click)="success = false" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div *ngIf="filteredMdAvailabilities">
  <div class="row">
    <div class="col-12">
      <p-panel [toggleable]="true">
        <ng-template pTemplate="header">
          <span class="filter-title p-panel-title"><i class="fa fa-search"></i>Filter</span>
        </ng-template>
        <div class="row">
          <div class="col-4">
            <p-floatLabel>
              <p-dropdown [(ngModel)]="filterParams.sourceCPop" (ngModelChange)="filter()" [filter]="true"
                          [options]="possibleSourcePopsOptions" [showClear]="true" name="name"></p-dropdown>
              <label style="left: 0">Source commercial pop</label>
            </p-floatLabel>
          </div>
          <div class="col-2">
            <p-floatLabel>
              <p-dropdown [(ngModel)]="filterParams.market" (ngModelChange)="filter()" [filter]="true"
                          [options]="possibleMarketsOptions" [showClear]="true" name="status"></p-dropdown>
              <label style="left: 0">Market</label>
            </p-floatLabel>
          </div>
          <div class="col-3">
            <div class="row">
              <div class="col-9">
                <div class="margin-checkbox pt-4">
                  <p-checkbox [(ngModel)]="filterParams.arbitrated" (ngModelChange)="filter()" binary="true"
                              label="Arbitrated" name="arbitrated"></p-checkbox>
                </div>
                <div class="margin-checkbox">
                  <p-checkbox [(ngModel)]="filterParams.non_arbitrated" (ngModelChange)="filter()"
                              binary="true" label="Non-Arbitrated" name="non-arbitrated"></p-checkbox>
                </div>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div class="row">
              <div class="col-9">
                <div class="margin-checkbox pt-4">
                  <p-checkbox [(ngModel)]="filterParams.encrypted" (ngModelChange)="filter()" binary="true"
                              label="Encrypted" name="encrypted"></p-checkbox>
                </div>
                <div class="margin-checkbox">
                  <p-checkbox [(ngModel)]="filterParams.non_encrypted" (ngModelChange)="filter()"
                              binary="true" label="Non-Encrypted" name="non-encrypted"></p-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <p-floatLabel>
              <p-dropdown [(ngModel)]="filterParams.destinationCPop" (ngModelChange)="filter()" [filter]="true"
                          [options]="possibleDestinationCPopsOptions" [showClear]="true" name="status"></p-dropdown>
              <label for="status" style="left: 0">Destination commercial pop</label>
            </p-floatLabel>
          </div>
          <div class="col-2">
            <p-floatLabel>
              <p-dropdown [(ngModel)]="filterParams.service" (ngModelChange)="filter()" [filter]="true"
                          [options]="possibleServicesOptions" [showClear]="true" name="name"></p-dropdown>
              <label style="left: 0">Service</label>
            </p-floatLabel>
          </div>
          <div class="col-3">
            <div class="row">
              <div class="col-9">
                <div class="margin-checkbox pt-4">
                  <p-checkbox [(ngModel)]="filterParams.protected" (ngModelChange)="filter()" binary="true"
                              label="Protected" name="protected"></p-checkbox>
                </div>
                <div class="margin-checkbox">
                  <p-checkbox [(ngModel)]="filterParams.non_protected" (ngModelChange)="filter()"
                              binary="true" label="Non-Protected" name="non-protected"></p-checkbox>
                </div>
              </div>
            </div>
          </div>
          <div *roles="['ROLE_MCKAY']" class="col-3">
            <div class="row">
              <div class="col-9">
                <div class="margin-checkbox pt-4">
                  <p-checkbox [(ngModel)]="filterParams.showUAT" (ngModelChange)="alterShowUat()" binary="true"
                              label="Show UAT" name="showUAT"></p-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-panel>
    </div>
  </div>

  <p-table [columns]="cols" [rowHover]="true" [tableStyle]="{'table-layout':'auto'}"
           [value]="filteredMdAvailabilities"
           id="qrd-multicast-table">
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of cols" [pSortableColumnDisabled]="col.sortable" [pSortableColumn]="col.field"
            class="p-sortable-column ng-star-inserted">
          {{ col.header }}
          <p-sortIcon *ngIf="!col.sortDisabled" [field]="col.field"></p-sortIcon>
          <i *ngIf="col.field === 'publicDescription'" class="fa fa-question-circle pull-right"
             pTooltip="This is a public description. It can be viewed by clients."
             style="color: grey;"></i>
        </th>
      </tr>
    </ng-template>
    <ng-template let-mdAvailability pTemplate="body">
      <tr *ngFor="let market of mdAvailability.markets; index as i">
        <td *ngIf="i === 0" [attr.rowspan]="mdAvailability.markets.length"
            style="vertical-align: top">{{ mdAvailability.cPop }} /
          <span
            [pTooltip]="technicalPopService.getCageTooltip(mdAvailability.technicalPop)">{{ mdAvailability.technicalPop }} </span>
          <i class="fa fa-question-circle"
             pTooltip="{{mdAvailability.technicalPopId}}"
             style="color: grey;"></i></td>
        <td style="vertical-align: top">{{ market['service'] | uppercase }}</td>
        <td style="vertical-align: top">{{ market['name'] }} ( {{ market['cPopDisplayId'] }} )</td>
        <td style="vertical-align: top">{{ market['platform'] }} <img *ngIf="isEncrypted(market)" alt=""
                                                                      pTooltip="Encrypted"
                                                                      src='assets/images/icons/encrypted_icon.png'
                                                                      style="width: 20px; height: 20px; vertical-align: middle;"></td>
        <td style="vertical-align: top">{{ market['options'] }}</td>
        <td *roles="['ROLE_MCKAY']">
          <textarea (focusin)="market.textAriaRows = 4" (focusout)="changePublicDescription(market)"
                    (keyup.enter)="changePublicDescription(market)"
                    [(ngModel)]="market.newPublicDescription"
                    [rows]="market.textAriaRows" class="form-control"
                    id="publicDescription"
                    name="publicDescription">
          </textarea>
        </td>
        <td *roles="['ROLE_CLIENT']"> {{ market['publicDescription'] }}</td>
        <td *roles="['ROLE_MCKAY']" style="vertical-align: top">{{ market['updatedBy'] }}</td>
        <td *roles="['ROLE_MCKAY']" style="vertical-align: top;">{{ market['updatedAt'] }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>




